import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';
import { createCookie } from '../../common/Cookie';
import { storageAvailable } from '../../common/storageAvailable';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class CategoryImages extends React.Component {
  TypeClassification(type, pageId) {
    const path = pageId;
    var date;
    if (storageAvailable('localStorage')) {
      localStorage.setItem('categoryClicked', pageId);
      createCookie('categoryClicked', pageId, 730);
      if (type == 'core') {
        localStorage.setItem('categoryType', 'core');
        localStorage.setItem('categoryPath', path);
        date = new Date();
        localStorage.setItem('coreSelectedOn', date);
        createCookie('categoryType', 'core', 730);
        createCookie('categoryPath', path, 730);
        createCookie('coreSelectedOn', date, 730);
      } else {
        localStorage.setItem('categoryType', 'noncore');
      }
    }
    // localStorage.setItem('clickNav', path);
  }

  render() {
    const { buttonsCatNav = {} } = this.props;
    const subTextObj =
      buttonsCatNav.filter((data = {}) => {
        if (data.content) {
          return true;
        }
        return false;
      })[0] || {};
    const { content: subtext = '' } = subTextObj;
    const { category } = this.props;
    if (this.props.category) {
      var typeSelected = localStorage.getItem('categoryClicked');
    }
    const buttonCategories =
      buttonsCatNav.filter(data => {
        if (data.nativeCategoryNavigationListDetails) {
          return true;
        }
        return false;
      })[0] || {};
    const { nativeCategoryNavigationListDetails = [] } = buttonCategories;
    const imageCatNavDetails = nativeCategoryNavigationListDetails
      ? nativeCategoryNavigationListDetails.map((categories, pop_key) => {
          let categoryNameImg = categories.imageDetails || [];
          let imgNameCategory = '';
          categoryNameImg.forEach(item => {
            if (item.imagePosition == 'NativeCategoryNameImage') {
              imgNameCategory = item.imageUrl;
            }
          });
          let categoryImg = categories.imageDetails || [];
          let imgCategory = '';
          categoryImg.forEach(item => {
            if (item.imagePosition == 'NativeCategoryImage') {
              imgCategory = item.imageUrl;
            }
          });
          return (
            <div className="btn-img-container" key={`cat-nav-popup-${pop_key}`}>
              {typeSelected === categories.nativeCategoryPageId ? (
                <a
                  href={categories.nativeCategoryPageId}
                  className="no-outline"
                  data-ga-event-category="bannerTap"
                  data-ga-event-action="buttonTap"
                  data-ga-event-label={categories.nativeCategoryName}
                >
                  <img
                    src={`${replaceWithJioCDN(imgNameCategory)}`}
                    className="btn-cat-nav-modal btn-selected-modal"
                    onClick={() => {
                      this.TypeClassification(
                        categories.nativeCategoryType,
                        categories.nativeCategoryPageId
                      );
                    }}
                  />
                  <div className="img-category-modal img-selected-modal no-overflow">
                    <img
                      src={`${replaceWithJioCDN(imgCategory)}`}
                      className="img-animate"
                      onClick={() => {
                        this.TypeClassification(
                          categories.nativeCategoryType,
                          categories.nativeCategoryPageId
                        );
                      }}
                    />
                  </div>
                </a>
              ) : (
                <a
                  href={categories.nativeCategoryPageId}
                  className="no-outline"
                  data-ga-event-category="bannerTap"
                  data-ga-event-action="buttonTap"
                  data-ga-event-label={categories.nativeCategoryName}
                >
                  <img
                    src={`${replaceWithJioCDN(imgNameCategory)}`}
                    className="btn-cat-nav-modal"
                    onClick={() => {
                      this.TypeClassification(
                        categories.nativeCategoryType,
                        categories.nativeCategoryPageId
                      );
                    }}
                  />
                  <div className="img-category-modal no-overflow">
                    <img
                      src={`${replaceWithJioCDN(imgCategory)}`}
                      className="img-animate"
                      onClick={() => {
                        this.TypeClassification(
                          categories.nativeCategoryType,
                          categories.nativeCategoryPageId
                        );
                      }}
                    />
                  </div>
                </a>
              )}
            </div>
          );
        })
      : null;

    return (
      <div>
        <div className="text-popup"> {subtext}</div>
        <div className="cat-nav-popup">{imageCatNavDetails}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { HomeReducer = {} } = state;
  const { pageDetails = [] } = HomeReducer;
  return {
    buttonsCatNav: pageDetails
  };
}

export default CategoryImages = connect(mapStateToProps)(CategoryImages);
